import NoResultsBlock from './NoResultsBlock';

export default NoResultsBlock;
